import {useState} from 'react';
import {Check} from 'lucide-react';
import {StripeProvider} from "./StripeProvider";
import {SUBSCRIPTION_OPTIONS} from '../../lib/onboarding/avatarConfig';

interface StripePaymentProps {
  onPaymentComplete: ({paymentMethodId, customerId, priceId}: {
    paymentMethodId: string,
    customerId: string,
    priceId: string
  }) => void;
  className?: string;
  email: string;
}

export default function StripePayment({
                                        email,
                                        onPaymentComplete,
                                        className = ''
                                      }: StripePaymentProps) {
  const [selectedPlan, setSelectedPlan] = useState(SUBSCRIPTION_OPTIONS[0]);

  return (
    <div className={`space-y-6 ${className}`}>
      {/* Welcome Message */}
      <div className="text-center mb-8">
        <h3 className="md:text-2xl font-bold text-gray-900 mb-4">
          Welcome to OneWin! 🎉
        </h3>
      </div>

      {/* Subscription Options */}
      <div className="space-y-4">
        <div className="space-y-4">
          {SUBSCRIPTION_OPTIONS.map((option) => (
            <button
              key={option.id}
              onClick={() => setSelectedPlan(option)}
              className={`
              w-full p-6 rounded-2xl border-2 text-left transition-all duration-200
              ${selectedPlan.id === option.id
                ? 'border-pink-400 bg-pink-50 shadow-md'
                : 'border-gray-200 hover:border-pink-300 hover:bg-pink-25'
              }
            `}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-3 mb-2">
                    <h4 className="text-lg font-semibold text-gray-900">{option.name}</h4>
                    {option.savings && (
                      <span className="bg-emerald-100 text-emerald-800 text-xs font-medium px-2 py-1 rounded-full">
                      {option.savings}
                    </span>
                    )}
                  </div>
                  <div className="flex items-baseline space-x-1">
                    <span className="text-2xl font-bold text-gray-900">{option.price}</span>
                    <span className="text-gray-600">{option.period}</span>
                  </div>
                </div>

                <div className={`
                w-6 h-6 rounded-full border-2 flex items-center justify-center
                ${selectedPlan.id === option.id
                  ? 'border-pink-400 bg-pink-400'
                  : 'border-gray-300'
                }
              `}>
                  {selectedPlan.id === option.id && (
                    <Check className="h-4 w-4 text-white"/>
                  )}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      <StripeProvider
        priceId={selectedPlan.priceId}
        email={email}
        onPaymentComplete={onPaymentComplete}
      />

      {/* Features List */}
      <div className="bg-gray-50 rounded-xl p-6">
        <h4 className="font-semibold text-gray-900 mb-4">What's included:</h4>
        <div className="space-y-3">
          {[
            'Daily WhatsApp prompts and check-ins',
            'AI-powered progress tracking',
            'Personalized coaching style',
            'Voice and text message support',
            'Weekly performance reports',
            'Accountability partner integration'
          ].map((feature, index) => (
            <div key={index} className="flex items-center space-x-3">
              <Check className="h-5 w-5 text-emerald-500 flex-shrink-0"/>
              <span className="text-gray-700">{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
